import { useState } from "react";

export function useRateAnalysisControlledState<T>(
  initialValue: T | undefined,
  initialSetValue: ((value: T) => void) | undefined,
  defaultValue: T,
): [T, (value: T) => void] {
  const isControlled = initialValue !== undefined && initialSetValue !== undefined;
  const [internalState, setInternalState] = useState<T>(defaultValue);

  const stateVal = isControlled ? (initialValue as T) : internalState;
  const setStateVal = isControlled ? (initialSetValue as (value: T) => void) : setInternalState;

  return [stateVal, setStateVal];
}
